import { OccupancyBand, occupancyBand } from "./occupancyBand";

type OccupancyPeriod = {
  from: string;
  to: string;
  occupancy: number;
  band: OccupancyBand;
};

const occupancyPeriod: OccupancyPeriod = {
  from: "",
  to: "",
  occupancy: 0,
  band: occupancyBand,
};

export type { OccupancyPeriod };

export { occupancyPeriod };
